module.exports = __webpack_public_path__ + "img/2025-03-12e_2.aa939512.jpg";